import { Helmet } from '@dr.pogodin/react-helmet';
import { Navigate, Route, Routes } from 'react-router';
import Loading from '../common/lib/Loading';
import PageNotFound from '../common/lib/PageNotFound';
import useJson from '../common/lib/useJson';
import XoopsCode from '../common/lib/XoopsCode';
import type { MultiLang } from '../config';
import NimgcenterBrainConv from './NimgcenterBrainConv';

interface Props {
    lang: MultiLang;
}

const StaticPage = (props: Props & { path: string }) => {
    const { lang, path } = props;
    const page = useJson<Record<MultiLang, string>>(path);
    if (typeof page === 'undefined') {
        return <Loading />;
    }
    if (page === null) {
        return <PageNotFound lang={lang} />;
    }
    return <XoopsCode lang={lang} text={page[lang]} dohtml={true} />;
};

const NimgcenterUtilities = (props: Props) => {
    const { lang } = props;
    return (
        <>
            <Helmet>
                <title>NIMG Utilities</title>
            </Helmet>
            <Routes>
                <Route
                    index
                    element={<StaticPage lang={lang} path="/modules/xnpnimgcenter/utilities/utilities.json" />}
                />
                <Route path="brain_conv/" element={<NimgcenterBrainConv lang={lang} />} />
                <Route
                    path="brain_conv/howtouse.php"
                    element={
                        <StaticPage lang={lang} path="/modules/xnpnimgcenter/utilities/brain_conv/howtouse.json" />
                    }
                />
                <Route path="index.php" element={<Navigate to="/modules/xnpnimgcenter/utilities/" replace />} />
                <Route
                    path="brain_conv/index.php"
                    element={<Navigate to="/modules/xnpnimgcenter/utilities/brain_conv/" replace />}
                />
                <Route path="*" element={<PageNotFound lang={lang} />} />
            </Routes>
        </>
    );
};

export default NimgcenterUtilities;
